import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { getCategories } from "../lib/api";
import SEO, { canonicalFor, titleFor } from "../lib/seo";

export default function Categories() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    getCategories().then(setItems).catch(() => {});
  }, []);

  return (
    <div data-testid="categories-page" className="max-w-6xl mx-auto px-6 md:px-10 py-12 md:py-16">
      <SEO
        title={titleFor("Food Categories — Snacks, Drinks, Dairy & More")}
        description="Explore ingredient safety ratings by food category. See how snacks, drinks, dairy, cereals, sauces, chocolate and sweets stack up."
        canonical={canonicalFor("/categories")}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Food Categories",
          description: "Browse analyzed food products by category.",
        }}
      />

      <div className="mb-8">
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[color:var(--text-3)] mb-2">Browse</div>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tighter">
          Food <span className="text-[color:var(--lime)]">categories</span>
        </h1>
        <p className="mt-3 text-[color:var(--text-2)] max-w-2xl">
          Every aisle, decoded. Pick a category to see the products we've analyzed and how they rate.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="categories-grid">
        {items.map((cat, i) => (
          <motion.div key={cat.slug} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.04 }}>
            <Link
              to={`/category/${cat.slug}`}
              data-testid={`category-tile-${cat.slug}`}
              className="surface rounded-xl p-5 block hover:border-[color:var(--lime)]/40 transition-colors h-full"
            >
              <div className="flex items-center justify-between mb-2">
                <div className="font-display text-xl font-semibold">{cat.name}</div>
                <span className="font-mono text-[10px] tracking-[0.15em] uppercase text-[color:var(--lime)]">
                  {cat.productCount}
                </span>
              </div>
              <p className="text-sm text-[color:var(--text-2)] leading-relaxed">{cat.description}</p>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
